import { QueueStatus } from '@config/constants/enum';
import { ActionIcon, Flex } from '@mantine/core';
import {
	IconEye,
	IconFileDownload,
	IconSend,
} from '@tabler/icons-react';
import { MouseEventHandler } from 'react';

export const CellActions = (props: {
	onShow: MouseEventHandler<HTMLButtonElement>;
	onDownload?: MouseEventHandler<HTMLButtonElement>;
	onSend?: MouseEventHandler<HTMLButtonElement>;
	isDownload?: boolean;
	isSend?: boolean;
	data: any;
}) => {
	const {
		onShow,
		onDownload,
		onSend,
		isDownload,
		isSend,
	} = props;
	return (
		<Flex gap="10px" justify={'flex-end'}>
			<ActionIcon
				h={'30px'}
				w={'30px'}
				variant="filled"
				radius={'xl'}
				color={'#DDF9ED'}
				onClick={onShow}
			>
				<IconEye
					color="#2C8C5E"
					size="18px"
					stroke={1.5}
				/>
			</ActionIcon>
			{isDownload && (
				<ActionIcon
					h={'30px'}
					w={'30px'}
					variant="filled"
					radius={'xl'}
					color="#E8F4FF"
					onClick={onDownload}
					disabled={
						props.data.status !== QueueStatus.SUCCESS
					}
				>
					<IconFileDownload
						color="#617EEF"
						size="18px"
						stroke={1.5}
					/>
				</ActionIcon>
			)}
			{isSend && (
				<ActionIcon
					h={'30px'}
					w={'30px'}
					variant="filled"
					radius={'xl'}
					color="#FEF2DC"
					onClick={onSend}
					disabled={
						props.data.status !== QueueStatus.SUCCESS
					}
				>
					<IconSend
						color="#F7C80A"
						size="18px"
						stroke={1.5}
					/>
				</ActionIcon>
			)}
		</Flex>
	);
};
